// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Page} from '../comp/page';
import {Cashout as Content} from '../features/cashout';

export function Cashout(){
    return <Page>
      <Content/>
    </Page>;
}
